import React from 'react';



function AgeContainer({ onStepClick, labels, configuration }) {
    return (
        <div>
            <div onClick={() => onStepClick(2)}  className="solea_age_selector">

                <div>
                    <h3>{labels.age.headline_children}</h3>
                    {labels.age.text_children}
                </div>
                <p className="solea_emblems_selection">
                    <img src={configuration.icon_children} class="solea_participant_icon" />


                </p>
            </div>

            <div onClick={() => onStepClick(3)}  className="solea_age_selector">
                <div>
                    <h3>{labels.age.headline_adults}</h3>
                    {labels.age.text_adults}
                </div>
                <p className="solea_emblems_selection">
                    <img src={configuration.icon_adults} className="solea_participant_icon"/>
                </p>
            </div>

        </div>
    );
}


export default AgeContainer;